module.exports = __webpack_public_path__ + "static/media/banner_lcdlm2_medium.7121e6f4.jpg";